
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Izvor podatkov',
	'dataSourceId': 'ID',
	'dataSourceType': 'Tip',
	'dataSourceName': 'Ime',
	'dataSourcePath': 'Pot',
	'showInfoForAll': 'Pokaži trajanje za vse vizualizacije',
	'hideInfoForAll': 'Skrij trajanje za vse vizualizacije',
	'showPerformanceDetails': 'Znova zaženi vse gradnike za vključitev podrobnosti o zmogljivosti',
	'slotMappingField': 'Preslikave reže',
	'slotDataMapping': 'Preslikava',
	'slotID': 'ID',
	'slotCaption': 'Napis',
	'slotMandatory': 'Obvezno',
	'slotIsMandatory': 'Da',
	'slotIsNotMandatory': 'Ne',
	'infoNotAvailable': 'Ni na voljo',
	'performanceSection': 'Zmogljivost',
	'durationField': 'Trajanje',
	'singleQueryTime': 'Poizvedba strežnika (ms)',
	'multipleQueryTime': 'Poizvedba strežnika %{name} (ms)',
	'liveWidgetTotalTime': 'Skupaj (ms)',
	'renderTimeNotAvailable': 'Ni na voljo',
	'renderInProgress': '(v teku)',
	'interactToTriggerQuery': 'Interakcija z gradnikom za sprožitev poizvedbe',
	'fetchQuery': 'Pridobi poizvedbo',
	'showSQLMDX': 'Pokaži SQL/MDX',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Informacije o poizvedbi',
	'queryInfoNotAvailable': 'Informacije o poizvedbi niso na voljo',
	'query': 'Poizvedba',
	'copy': 'Prekopiraj',
	'close': 'Zapri'
});
